export const BUSINESS_START_HOUR = 9;
export const BUSINESS_END_HOUR = 17;

enum WeekDay {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

/** Mutable Date */
type DateMut = Date;

export function setToWorkingHour(date: DateMut): Date {
  const h = date.getHours();
  if (h < BUSINESS_START_HOUR) {
    date.setHours(BUSINESS_START_HOUR);
  }
  if (h >= BUSINESS_END_HOUR) {
    date.setHours(BUSINESS_END_HOUR - 1);
  }
  return date;
}

export function setToWorkingDay(date: DateMut): Date {
  const day = date.getDay();
  if (day === WeekDay.SUNDAY) {
    // sunday turns to monday
    date.setDate(date.getDate() + 1);
  } else if (day === WeekDay.SATURDAY) {
    // saturday turns to friday
    date.setDate(date.getDate() - 1);
  }
  return date;
}

function roundToWorkingHours(date: DateMut): Date {
  if (localStorage.getItem('shouldIgnoreWorkingHours') === 'true') {
    return date;
  }

  return setToWorkingDay(setToWorkingHour(date));
}

export function followUpScheduleInMinutes(
  minutes: string | undefined,
  defaultMinutes: number,
  start?: Date,
): Date | undefined {
  let minutesNumber = defaultMinutes;
  if (minutes && typeof minutes === 'string') {
    minutesNumber = parseFloat(minutes);
    if (!Number.isInteger(minutesNumber)) {
      // deliberately set to a non-number
      return;
    }
  }

  const now = start ? new Date(start.getTime()) : new Date();
  now.setMinutes(now.getMinutes() + minutesNumber);
  return roundToWorkingHours(now);
}
